import logoFull from '../assets/logo-full.png';
import logoStacked from '../assets/logo-stacked.png';
import logoIcon from '../assets/logo-icon.png';
import logoWordmark from '../assets/logo-wordmark.png';
import logoBean from '../assets/logo-bean.png';

export type LogoVariant = 'full' | 'stacked' | 'icon' | 'wordmark' | 'bean';
export type LogoSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface LogoProps {
  variant?: LogoVariant;
  size?: LogoSize;
  className?: string;
  alt?: string;
}

const logoSources: Record<LogoVariant, string> = {
  full: logoFull,
  stacked: logoStacked,
  icon: logoIcon,
  wordmark: logoWordmark,
  bean: logoBean,
};

const sizeClasses: Record<LogoVariant, Record<LogoSize, string>> = {
  full: {
    xs: 'h-8',
    sm: 'h-10',
    md: 'h-12',
    lg: 'h-16',
    xl: 'h-24',
  },
  stacked: {
    xs: 'h-12',
    sm: 'h-16',
    md: 'h-24',
    lg: 'h-32',
    xl: 'h-48',
  },
  icon: {
    xs: 'h-6 w-6',
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-14 w-14',
    xl: 'h-20 w-20',
  },
  wordmark: {
    xs: 'h-4',
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-10',
    xl: 'h-14',
  },
  bean: {
    xs: 'h-6',
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-12',
    xl: 'h-16',
  },
};

export function Logo({
  variant = 'full',
  size = 'md',
  className = '',
  alt = 'JumpBean',
}: LogoProps) {
  const src = logoSources[variant];
  const sizeClass = sizeClasses[variant][size];

  return (
    <img
      src={src}
      alt={alt}
      className={`${sizeClass} ${className}`}
    />
  );
}
